// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {actions as GeneralAction} from '../../../configure/general/duck';
import {actions as CurrencyAction} from '../../../currency/duck';
import {actions as CountryAction} from '../../../country/duck';
import StoreConfig from '../components/StoreConfig';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    contact: state.information.contact,
    contactTypes: state.information.contactTypes,
    information: state.ui.storeInformation,
    countries: state.country.countries,
    country: state.country.country,
    fetchCountryError: state.country.fetchCountryError,
    currencies: state.currency.currencies,
    currency: state.currency.currency,
    fetchCurrencyError: state.currency.fetchCurrencyError,
    countryByGeo: state.currency.country,
    user: state.auth.user,
    validationResult: state.onBoarding.validationResult,
    isValidating: state.onBoarding.isValidating,
    storeTypes: state.onBoarding.storeTypes,
    isGettingStoreTypes: state.onBoarding.isGettingStoreTypes,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...GeneralAction,
        ...CurrencyAction,
        ...CountryAction,
      },
      dispatch
    )
)(StoreConfig);
